import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const SearchState = Immutable.fromJS({
	eventKey: 0,
	allOrderIds: [],
	alertStyle: null,
	alertMessage: null,
	searchCheckResult: null
});

const searchReducer = handleActions({
	FIND_SEARCH_EPC_LIST: (state, { payload }) => {
		let sAlertStyle = null;
		let sAlertMessage = null;
		if (payload.statusCode && payload.statusCode !== '0') {
			sAlertStyle = 'warning';
			sAlertMessage = payload.displayMessage;
		}
		return state.merge({
			alertStyle: sAlertStyle,
			alertMessage: sAlertMessage,
		})
	},
	FIND_ALL_ORDERIDS: (state, { payload }) => {
		return state.merge({
			allOrderIds: payload.data
		})
	},
	CLEAN_SEARCH_EPC_ALERT: (state, { payload }) => {
		return state.merge({
			alertStyle: null,
			alertMessage: null,
			searchCheckResult: null
		})
	},
	FIND_SEARCH_EPC_CHECK: (state, { payload }) => {
		return state.merge({
			searchCheckResult: payload.data
		})
	}
}, SearchState);

export default searchReducer;


// WEBPACK FOOTER //
// ./src/reducers/searchReducer.js